export default function validateFields (record, state, accountType) {
  const { firstName, lastName, username, email, password, manualPassword, name, } = state
  const geoState = state.state
  const isStudent = record.role === 'Student'
  const isEducator =  record.role === 'District Admin' ||
                      record.role === 'School Admin' ||
                      record.role === 'Teacher'
  const is_admin = record.role === 'District Admin' ||
                   record.role === 'School Admin'
  const is_student_or_teacher = record.role === 'Student' ||
                                record.role === 'Teacher'
  if (isEducator || isStudent) {
    if (!lastName) {
      return {lastName: 'Last name required.'}
    }
  } else {
    if (!name) {
      return {name: 'Name is required.'}
    }
    if (!geoState && accountType === 'District') {
      return {state: 'State is required.'}
    }
  }
  if (is_admin) {
    if (!email) {
      return {email: 'Email required.'}
    }
  }
  if (is_student_or_teacher) {
    if (!email && !username) {
      return {username: 'Email or username required.'}
    }
    if (!email && username && username.length < 6) {
      return {username: 'Username must have at least six characters.'}
    }
  }
  if (manualPassword) {
    if (!password) {
      return {password: 'Password is required.'}
    }
  }
  if (email) {
    const checkAt = email.indexOf('@') === -1
    const checkDot = email.indexOf('.') === -1
    if (checkAt || checkDot) {
      return {email: 'Email invalid.'}
    }
  }
  return null
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/validateFields.js